var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { CorrectWrongButton, CorrectWrongValue } from '../../../classes/learnware/LearnwareEnums';
import { primitive } from '../../../utils/serializr/schema/inner/primitive';
import { withInit } from '../../../utils/serializr/schema/middle/withInit';
import { legacy } from '../../../utils/serializr/schema/outer/legacy';
import { MultipleChoiceStore } from '../../MultipleChoice/modules/MultipleChoiceStore';
import { CorrectWrongLegacy } from './CorrectWrongLegacy';
export class CorrectWrongStore extends MultipleChoiceStore {
    constructor({ parent }) {
        super({ parent });
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get correctWrongLegacy() {
        return new CorrectWrongLegacy(this);
    }
    get buttons() {
        if (this.allOptions[0].text.textBasis === 'Richtig' && this.allOptions[1].text.textBasis === 'Falsch') {
            return CorrectWrongButton.CorrectWrong;
        }
        if (this.allOptions[0].text.textBasis === 'Ja' && this.allOptions[1].text.textBasis === 'Nein') {
            return CorrectWrongButton.YesNo;
        }
        return CorrectWrongButton.Custom;
    }
    set buttons(buttonNumber) {
        if (!buttonNumber || buttonNumber === CorrectWrongButton.CorrectWrong) {
            this.allOptions[0].text.textBasis = 'Richtig';
            this.allOptions[1].text.textBasis = 'Falsch';
        }
        if (buttonNumber === CorrectWrongButton.YesNo) {
            this.allOptions[0].text.textBasis = 'Ja';
            this.allOptions[1].text.textBasis = 'Nein';
        }
        this.numberOfOptions = 2;
    }
    get correct() {
        if (this.allOptions[0].shouldBeSelected) {
            return CorrectWrongValue.StatementIsCorrect;
        }
        return CorrectWrongValue.StatementIsWrong;
    }
    set correct(statmentIsCorrect) {
        this.allOptions[0].shouldBeSelected = statmentIsCorrect === CorrectWrongValue.StatementIsCorrect;
        this.allOptions[1].shouldBeSelected = statmentIsCorrect === CorrectWrongValue.StatementIsWrong;
    }
    get legacyImages() {
        return undefined;
        return this.correctWrongLegacy.legacyImages;
    }
    set legacyImages(l) {
        if (!l)
            return;
        this.correctWrongLegacy.legacyImages = l;
    }
    get legacyComments() {
        return undefined;
        return this.correctWrongLegacy.legacyComments;
    }
    set legacyComments(l) {
        if (!l)
            return;
        this.correctWrongLegacy.legacyComments = l;
    }
    get label1() {
        return this.allOptions[0].innerTextString;
    }
    set label1(text) { }
    get label2() {
        return this.allOptions[1].innerTextString;
    }
    set label2(text) { }
    static get serializeInfo() {
        return {
            extends: MultipleChoiceStore.serializeInfo,
            props: {
                buttons: legacy(withInit(primitive, 0)),
                correct: legacy(primitive),
                label1: legacy(primitive),
                label2: legacy(primitive),
            },
        };
    }
}
__decorate([
    memoize
], CorrectWrongStore.prototype, "correctWrongLegacy", null);
__decorate([
    computed
], CorrectWrongStore.prototype, "buttons", null);
__decorate([
    computed
], CorrectWrongStore.prototype, "correct", null);
__decorate([
    computed
], CorrectWrongStore.prototype, "legacyImages", null);
__decorate([
    computed
], CorrectWrongStore.prototype, "legacyComments", null);
__decorate([
    memoize
], CorrectWrongStore, "serializeInfo", null);
